import React from "react";
import PropTypes from "prop-types";

import { Button, Icon, Responsive } from "semantic-ui-react";

function ButtonGroup({ icon, iconCorner, text, showGearIcon, ...props }) {
  return (
    <Button basic icon={text === ""} {...props}>
      <Icon.Group>
        <Icon name={icon} />
        {showGearIcon && <Icon corner name={iconCorner} />}
      </Icon.Group>
      {text && <span style={{ marginLeft: "0.428571em" }}>{text}</span>}
    </Button>
  );
}
export function TriggerButton({ icon, onClick, showGearIcon, ...props }) {
  return (
    <React.Fragment>
      <Responsive maxWidth={1350}>
        <ButtonGroup
          icon={icon}
          onClick={onClick}
          showGearIcon={showGearIcon}
        />
      </Responsive>
      <Responsive minWidth={1351} style={{ whiteSpace: "nowrap" }}>
        <ButtonGroup
          icon={icon}
          onClick={onClick}
          showGearIcon={showGearIcon}
          {...props}
        />
      </Responsive>
    </React.Fragment>
  );
}

ButtonGroup.defaultProps = {
  iconCorner: "cog",
  text: "",
  showGearIcon: true,
};

ButtonGroup.propTypes = {
  icon: PropTypes.string.isRequired,
  iconCorner: PropTypes.string,
  text: PropTypes.string,
  showGearIcon: PropTypes.bool,
};

TriggerButton.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  showGearIcon: PropTypes.bool,
};

TriggerButton.defaultProps = {
  showGearIcon: true,
};

export default TriggerButton;
